import { toAbsoluteUrl } from '_metronic/helpers';
// import Button from 'bootstrap/js/dist/button';
import Button from 'react-bootstrap/Button';
import React from 'react';
import { useHistory } from 'react-router-dom';

const PaymentSuccess: React.FC = () => {
  const history = useHistory();


  return (
    <div className='card'>
      <div className='card-body p-lg-17'>
        <div className='mb-18'>
          <div className='text-center'>
            <h1 className='fs-2hx text-dark mb-5'>Payment Successful!</h1>
            <div className='fs-5 text-muted fw-bold'>
              Your job fair payment has been processed successfully.
            </div>
          </div>
        </div>
        <div className='mb-16'>
          <div className='d-flex flex-center'>
            <img
              src={toAbsoluteUrl('/media/illustrations/sketchy-1/5.png')}
              className='mw-100 mh-300px'
              alt=''
            />
          </div>
        </div>
        <div className='mb-15 text-center'>
          <div className='fs-5 text-muted fw-bold'>
            Your job fair is now active. Next, please add your Recruiter(s) and then assign to their respective booths.</div>
        </div>
        <Button
          className='text-center mx-auto d-block mb-10'
          variant='primary'
          size='lg'
          onClick={() => history.push('/employer-admin/dashboard?step=3')}
        >
          <b>Add Recruiters</b>
        </Button>
      </div>
    </div>
  );
};

export default PaymentSuccess;
